import React, { Component } from 'react';
import { Modal, Radio, Input, message, Spin } from 'antd';
import HighSearchInput from '../../common/HighSearchInput';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';

const { TextArea } = Input; 
const RadioGroup = Radio.Group;

class UpdateResearcher extends Component {
    state = {
        params: {},
        visible: false,
        loading: false,
    }

    show = (record) => {
        const params = {
            ...(record || {}),
        };
        this.setState({
            params,
            visible: true,
            isEdit: !!record,
        });
    }

    hide = () => {
        this.setState({
            visible: false,
            userOptions: [],
        });
    }

    submit = () => {
        const {
            isEdit,
            params,
            userOptions = [],
        } = this.state;
        const { userId, typeName } = params;
        const { hospitalDepartmentId } = this.props;
        if (typeName !== 'DEFAULT') {
            if (userId) {
                const isExist = userOptions.some(item => item.value == userId);
                if (!isExist) {
                    message.warning('请选择正确的PI姓名');
                    return;
                }
            } else {
                message.warning('请选择PI姓名');
                return;
            }
        }

        let url;
        if (isEdit) {
            url = API_URL.hospital.modifyReviewPi;
        } else {
            url = API_URL.hospital.addReviewPi;
        }
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url,
            data: {
                ...params,
                hospitalDepartmentId,
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.setState({
                    loading: false,
                }, () => {
                    this.hide();
                    this.props.loadData(userId);
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    handleInputChange = (e, key) => {
        const { params } = this.state;
        params[key] = e.target.value;
        this.setState({ params });
    }

    handleSelectChange = (value, key) => {
        const { params } = this.state;
        params[key] = value;
        this.setState({
            params,
        });
    }

    handleHighSearchInputChange = (id, options, idName, optionsName) => {
        const { params } = this.state;
        params[idName] = id;
        const option = options.find(i => i.value == id);
        const { text } = option || {};
        params.userName = text;
        this.setState({
            params,
            [optionsName]: options,
        });
    }

    getContent = () => {
        const { isEdit, params, visible } = this.state;
        const {
            userId,
            reviewPiId,
            userCompellation,
            whetherParticipateActualProject,
            whetherParticipateActualProjectShow,
            gcpAwareness,
            cooperationDegree,
            cfdaInspectionExperience,
            acceptCrcService,
            speciallyAssignedPerson,
            closeCooperation,
            recommendationIndex,
            whetherSsuPsv,
            whetherSsuLead,
            whetherTakeProject,
            comments,
            typeName,
        } = params;
        const { hospitalDepartmentId } = this.props;
        const asterisk = <span style={{ color: 'red' }}>*</span>;
        return (
            <ul className="modal-list">
                <li className="modal-item">
                    <div className="item-left">{!(typeName === 'DEFAULT') && asterisk}PI姓名:</div>
                    <div className="item-right">
                        {
                            typeName === 'DEFAULT' ?
                                userCompellation
                            :
                                visible &&
                                <HighSearchInput
                                    isEdit={isEdit}
                                    keyword='keyword'
                                    style={{ width: 240 }}
                                    params={{ limit: 20, hospitalDepartmentId, type: 'pi', optionType: 'INSERT', reviewPiId }}
                                    placeholder="输入姓名/手机号检索"
                                    url={API_URL.hospital.queryDoctorListByHospitalDepartment}
                                    initValue={{ key: userId, label: userCompellation }}
                                    config={{ id: 'userId', name: 'userCompellation', type: 'researcher' }}
                                    onChange={(id, options) => this.handleHighSearchInputChange(id, options, 'userId', 'userOptions')}
                                />
                        }
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left">是否参与津石实际项目:</div>
                    <div className="item-right">
                        {
                            typeName === 'DEFAULT' ?
                                whetherParticipateActualProjectShow
                            :
                                <RadioGroup value={whetherParticipateActualProject} onChange={e => this.handleInputChange(e, 'whetherParticipateActualProject')}>
                                    <Radio value="YES">是</Radio>
                                    <Radio value="NO">否</Radio>
                                </RadioGroup>
                        }
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left">该PI所在团队的GCP意识:</div>
                    <div className="item-right">
                        <RadioGroup value={gcpAwareness} onChange={e => this.handleInputChange(e, 'gcpAwareness')}>
                            <Radio value="Strong">强</Radio>
                            <Radio value="Medium">中</Radio>
                            <Radio value="Average">一般</Radio>
                            <Radio value="Poor">差</Radio>
                        </RadioGroup>
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left">该PI所在团队的配合度:</div>
                    <div className="item-right">
                        <RadioGroup value={cooperationDegree} onChange={e => this.handleInputChange(e, 'cooperationDegree')}>
                            <Radio value="Good">好</Radio>
                            <Radio value="Medium">中</Radio>
                            <Radio value="Average">一般</Radio>
                            <Radio value="Poor">差</Radio>
                        </RadioGroup>
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left">该PI所在团队的CFDA视察经验:</div>
                    <div className="item-right">
                        <RadioGroup value={cfdaInspectionExperience} onChange={e => this.handleInputChange(e, 'cfdaInspectionExperience')}>
                            <Radio value="YES">有</Radio>
                            <Radio value="NO">无</Radio>
                        </RadioGroup>
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left"  style={{ lineHeight: '20px' }}>该PI所在团队是否接受津石&nbsp;<br/>CRC服务:</div>
                    <div className="item-right">
                        <RadioGroup value={acceptCrcService} onChange={e => this.handleInputChange(e, 'acceptCrcService')}>
                            <Radio value="YES">是</Radio>
                            <Radio value="NO">否</Radio>
                        </RadioGroup>
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left"  style={{ lineHeight: '20px' }}>该PI所在团队有无专人负责&nbsp;<br/>临床试验:</div>
                    <div className="item-right">
                        <RadioGroup value={speciallyAssignedPerson} onChange={e => this.handleInputChange(e, 'speciallyAssignedPerson')}>
                            <Radio value="YES">有</Radio>
                            <Radio value="NO">无</Radio>
                        </RadioGroup>
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left">津石合作紧密程度:</div>
                    <div className="item-right">
                        <RadioGroup value={closeCooperation} onChange={e => this.handleInputChange(e, 'closeCooperation')}>
                            <Radio value="GOOD">好</Radio>
                            <Radio value="Better">较好</Radio>
                            <Radio value="Average">中</Radio>
                            <Radio value="Poor">差</Radio>
                        </RadioGroup>
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left">该PI所在团队推荐指数:</div>
                    <div className="item-right">
                        <RadioGroup value={recommendationIndex} onChange={e => this.handleInputChange(e, 'recommendationIndex')}>
                            <Radio value="Highly_Recommended">极力推荐</Radio>
                            <Radio value="Recommended">推荐</Radio>
                            <Radio value="Generally_Recommended">一般</Radio>
                            <Radio value="Not_Recommended">不推荐</Radio>
                        </RadioGroup>
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left" style={{ lineHeight: '20px' }}>PI/科室是否可以接受&nbsp;<br/>SSU进行PSV:</div>
                    <div className="item-right">
                        <RadioGroup value={whetherSsuPsv} onChange={e => this.handleInputChange(e, 'whetherSsuPsv')}>
                            <Radio value="YES">是</Radio>
                            <Radio value="NO">否</Radio>
                        </RadioGroup>
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left" style={{ lineHeight: '20px' }}>PI/科室是否可以接受SSU&nbsp;<br/>主导合同沟通:</div>
                    <div className="item-right">
                        <RadioGroup value={whetherSsuLead} onChange={e => this.handleInputChange(e, 'whetherSsuLead')}>
                            <Radio value="YES">是</Radio>
                            <Radio value="NO">否</Radio>
                        </RadioGroup>
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left" style={{ lineHeight: '20px' }}>PI是否愿意承接I期项目:</div>
                    <div className="item-right">
                        <RadioGroup value={whetherTakeProject} onChange={e => this.handleInputChange(e, 'whetherTakeProject')}>
                            <Radio value="YES">是</Radio>
                            <Radio value="NO">否</Radio>
                        </RadioGroup>
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left">该PI所在团队备注:</div>
                    <div className="item-right">
                        <TextArea
                            rows={4}
                            maxLength="200"
                            placeholder="请输入"
                            value={comments}
                            onChange={e => this.handleInputChange(e, 'comments')}
                            style={{ width: 350, verticalAlign: 'text-top' }}
                        />
                    </div>
                </li>
            </ul>
        )
    }

    render() {
        const { isEdit, visible, loading } = this.state;
        return (
            <Modal
                title={`${isEdit ? '修改' : '添加'}PI团队点评`}
                visible={visible}
                onCancel={this.hide}
                onOk={this.submit}
                className="setjde-modal addchildcontract"
                wrapClassName="vertical-center-modal"
                bodyStyle={{ maxHeight: 500 }}
                confirmLoading={loading}
                maskClosable={false}
                width="600px"
            >
                 <Spin spinning={loading}>
                    <div className="modal-content" style={{ padding: '0 20px' }}>
                        {this.getContent()}
                    </div>
                </Spin>
            </Modal>
        )
    }
}

export default UpdateResearcher;


// WEBPACK FOOTER //
// ./src/components/hospital/commentInfo/UpdatePITeam.js